import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ShippingInstructionService} from '../../@shared/services/shipping-instruction.service';
import {MessageService} from 'primeng/api';

@Component({
    selector: 'address-management',
    templateUrl: './address-management.component.html',
    styleUrls: ['./address-management.component.scss']
})
export class AddressManagementComponent implements OnInit {

    addressForm: FormGroup | any;
    @Input() addressVO: any;
    @Input() isUpdateAddress = false;
    @Output() addressEmit: EventEmitter<any> = new EventEmitter<any>();
    countries: any[] = [];

    constructor(private siService: ShippingInstructionService, private messageService: MessageService) {
    }

    ngOnInit(): void {
        this.createAddressForm();
        this.getCountries();
    }

    getUserContactById(userContactId?: any) {
        this.siService
            .getUserContactById(userContactId)
            .subscribe(
                (x) => {
                    this.addressVO = x;
                    this.createAddressForm(x);
                }
            );
    }

    getCountries() {
        this.siService
            .getCountries()
            .subscribe(
                (x) => {
                    this.countries = x;
                }
            );
    }


    createAddressForm(addressVO?: any) {
        this.addressForm = new FormGroup(
            {
                companyName: new FormControl(addressVO?.companyName ? addressVO?.companyName : '', [Validators.required]),
                emailId: new FormControl(addressVO?.emailId ? addressVO?.emailId : '', [Validators.required, Validators.email]),
                phoneNumber: new FormControl(addressVO?.phoneNumber ? addressVO?.phoneNumber : ''),
                faxNumber: new FormControl(addressVO?.faxNumber ? addressVO?.faxNumber : ''),
                address: new FormControl(addressVO?.address ? addressVO?.address : '', [Validators.required]),
                city: new FormControl(addressVO?.city ? addressVO?.city : ''),
                state: new FormControl(addressVO?.state ? addressVO?.state : ''),
                country: new FormControl(addressVO?.country ? addressVO?.country : '', [Validators.required]),
                zipCode: new FormControl(addressVO?.zipCode ? addressVO?.zipCode : ''),
                domainName: new FormControl(addressVO?.domainName ? addressVO?.domainName : ''),
                role: new FormControl(addressVO?.role ? addressVO?.role : ''),
                userContactId: new FormControl(addressVO?.userContactId ? addressVO?.userContactId : ''),
                userId: new FormControl(addressVO?.userId ? addressVO?.userId : '')
            }
        );
    }

    closeAddressDialog() {
        this.addressEmit.emit({});
    }

    onSaveOfAddress(action) {
        if (!this.addressForm.valid) {
            this.messageService.add({
                key: 'si-messages',
                severity: 'error',
                summary: 'Error saving address !',
                detail: 'Required mandatory * fields !'
            });
            return;
        }
        this.addressEmit.emit({
            addressPayload: this.addressForm.value,
            action
        });
    }
}
